import React from 'react';
import type { SalesInvoice, SalesInvoiceItem } from '@/services/salesInvoice.service';
import type { ApprovalPrintSigner } from '@/services/approval.service';
import { EngineSalesInvoicePrint } from '@/components/print/EngineLetterheadPrints';

export interface CompanyPrintInfo {
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  taxNumber?: string;
  bankName?: string;
  bankAccountNo?: string;
  bankIban?: string;
  bankRoutingCode?: string;
  bankSwiftCode?: string;
  bankAddress?: string;
  logo?: string;
}

export type SalesInvoicePrintVariant = 'preprinted' | 'letterhead';

export interface PrintableSalesInvoiceProps {
  invoice: SalesInvoice;
  items: SalesInvoiceItem[];
  revenueServiceTypeLabel?: string;
  companyInfo?: CompanyPrintInfo;
  approvalSigners?: ApprovalPrintSigner[];
  qrImageDataUrl?: string | null;
  clearanceNumber?: string | null;
  eInvoiceUuid?: string | null;
  printVariant?: SalesInvoicePrintVariant;
  onClose?: () => void;
}

/** Tax invoice print — shared pagination engine with restored letter layout. */
export const PrintableSalesInvoice: React.FC<PrintableSalesInvoiceProps> = ({
  invoice,
  items,
  companyInfo,
  revenueServiceTypeLabel,
  approvalSigners,
  printVariant = 'letterhead',
  onClose,
}) => (
  <EngineSalesInvoicePrint
    invoice={invoice}
    items={items}
    companyInfo={companyInfo}
    revenueServiceTypeLabel={revenueServiceTypeLabel}
    approvalSigners={approvalSigners}
    printVariant={printVariant}
    onClose={onClose}
  />
);
